import { render, staticRenderFns } from "./ProgramSponsorJoboffers.vue?vue&type=template&id=5ef1613c&scoped=true&"
import script from "./ProgramSponsorJoboffers.vue?vue&type=script&lang=js&"
export * from "./ProgramSponsorJoboffers.vue?vue&type=script&lang=js&"
import style0 from "./ProgramSponsorJoboffers.vue?vue&type=style&index=0&id=5ef1613c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef1613c",
  null
  
)

export default component.exports